import { render } from "./LandingSection.vue?vue&type=template&id=7f795a2c&scoped=true"
import script from "./LandingSection.vue?vue&type=script&lang=js"
export * from "./LandingSection.vue?vue&type=script&lang=js"

import "./LandingSection.vue?vue&type=style&index=0&id=7f795a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f795a2c"]])

export default __exports__